import { render, staticRenderFns } from "./TPassHeader.vue?vue&type=template&id=a6d84a0c&"
import script from "./TPassHeader.vue?vue&type=script&lang=js&"
export * from "./TPassHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports